module.exports = __webpack_public_path__ + "static/media/horma-pie-plano.8ba59189.png";